import { Link } from "react-router-dom";

import {
  getPropertyStatusLabel,
  getPropertyStatusTone,
  getPropertyVisibilityHint,
  getLifecycleNotice,
  isModerationLocked,
} from "../../realty/lib/propertyLifecycle";

const buildSubtitleAddress = (property) => {
  const loc = property && property.location;
  if (!loc) return "";
  if (loc.formatted_address) return loc.formatted_address;
  const named = loc.address_object && loc.address_object.name
    ? loc.address_object.name
    : loc.manual_address_object;
  const parts = [
    loc.settlement_name || (loc.settlement_unit && loc.settlement_unit.name),
    loc.local_area,
    named,
    loc.building_number,
  ].filter(Boolean);
  return parts.join(" • ");
};

function EditHeader({ property }) {
  const status = (property && property.status) || "draft";
  const statusLabel = getPropertyStatusLabel(status);
  const statusTone = getPropertyStatusTone(status);
  const visibilityLabel = getPropertyVisibilityHint(status);
  const notice =
    status === "archived" && isModerationLocked(property)
      ? getLifecycleNotice(property)
      : null;
  const subtitle = property
    ? [property.title, buildSubtitleAddress(property)].filter(Boolean).join(" — ")
    : "";
  const backHref = property ? `/realty/${property.id}` : "/feed";

  return (
    <header className="ap-header">
      <Link to={backHref} className="cd-back">
        <i className="fa-solid fa-arrow-left" aria-hidden="true" />
        До оголошення
      </Link>
      <div className="ap-header__row">
        <div className="ap-header__text">
          <h1>Редагувати оголошення</h1>
          {subtitle ? (
            <p className="ap-header__subtitle">
              <i className="fa-solid fa-location-dot" aria-hidden="true" />
              {subtitle}
            </p>
          ) : null}
          <p>
            Усі зміни зберігаються після натискання{" "}
            <strong>Зберегти зміни</strong>. Поки не збережено — статус і
            видимість оголошення не змінюються.
          </p>
        </div>
        <div className="ap-header__status">
          <span
            className={`status-chip status-chip--${statusTone}`}
            title="Поточний статус оголошення"
          >
            <span className="dot" aria-hidden="true" />
            {statusLabel}
          </span>
          <small>{visibilityLabel}</small>
          {notice ? <small role="note">{notice}</small> : null}
        </div>
      </div>
    </header>
  );
}

export default EditHeader;
